const en = {
  message: {
    hello: 'Hello, {name}',
  },
}

export default en
